import Cookies from "js-cookie"
import { connect } from "react-redux"

import { toggleCountryModal } from "app-store-v2/app/actions"

export default function withGeo(WrappedComponent) {
  const WithGeo = (props) => <WrappedComponent {...props} />

  const mapStateToProps = (state) => {
    const geo = Cookies.get("geo")
    const site_country = sl.config.site_country_for_analytics
    return {
      geoCookie: geo || site_country,
      geoCookieDefault: geo,
      isMobile: state.browser.is.mobile,
      selectedGeoCookie: Cookies.get("selected_geo"),
      showCountryModal: !!state.localeHM.showCountryModal,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      setSelectedGeo: (geo) => {
        Cookies.set("selected_geo", geo, { expires: 365, secure: true })
      },
      toggleCountryModal: (toggle) => {
        dispatch(toggleCountryModal(toggle))
      },
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithGeo)
}
